import React from 'react';
import type {PhotoReference} from '../../services/photos/contracts';
export default function PhotoWildlifeSummary({photo,detail=false}:{photo:PhotoReference;detail?:boolean}){
 const w=photo.wildlife;if(!w)return null;
 return <div className={detail?'text-sm text-stone-600 space-y-1':'text-xs text-stone-600 mt-2'}>
  <p>{w.points===null?'Points unknown':`${w.points} points${w.pointBasis==='estimated'?' · estimated':''}`}</p>
  <p>{w.estimate?`B&C est. ${w.estimate.low}–${w.estimate.high} in`:'B&C not estimated'}</p>
  {detail&&<p className="text-xs pt-2">Rough gross estimates from a photograph, not measured scores.{w.reviewed?' Human-reviewed observation.':''}</p>}
  {detail&&(w.subjectCount||0)>1&&<p className="text-xs">{w.subjectCount} bucks recorded. Showing the highest estimate among those matching your point filter.</p>}
 </div>;
}
